import { container } from "tsyringe";
import ApiService from "@/app/infrastructures/services/ApiService";
import { PickupDashboardApiRepository } from "@/app/infrastructures/repositories/api/PickupDashboardApiRepository";
import { PickupDashboardMapper } from "@/data/persistences/mappers/PickupDashboardMapper";
import { PickupDashboardEndpoint } from "@/app/infrastructures/endpoints/PickupDashboardEndpoint";
import { PickupDashboardPresenter } from "@/app/ui/presenters/PickupDashboardPresenter";

export class PickupDashboardComponent {
  public static init() {
    container.register<PickupDashboardApiRepository>(
        PickupDashboardApiRepository,
      {
        useFactory: d => {
          return new PickupDashboardApiRepository(
            d.resolve(ApiService),
            d.resolve(PickupDashboardMapper),
            d.resolve(PickupDashboardEndpoint)
          );
        }
      }
    );
    container.register<PickupDashboardMapper>(PickupDashboardMapper, {
      useClass: PickupDashboardMapper
    });
    container.register<PickupDashboardPresenter>(
        PickupDashboardPresenter,
      {
        useFactory: d => {
          return new PickupDashboardPresenter(
            d.resolve(PickupDashboardApiRepository)
          );
        }
      }
    );
  }
}
